<section class="req-automation" aria-labelledby="req-automation-heading">
  <header class="req-automation__header">
    <mat-icon class="req-automation__header-icon" aria-hidden="true">settings</mat-icon>
    <h3 id="req-automation-heading" class="req-automation__title">
      {{ 'requirements.form.automation.blockTitle' | translate }}
    </h3>
  </header>

  <div class="req-automation__field">
    <div id="req-automation-id-label" class="req-automation__label">
      {{ 'requirements.form.automation.idLabel' | translate }}
    </div>

    @if (automationKey(); as key) {
      <div class="req-automation__id-row">
        <code class="req-automation__id" aria-labelledby="req-automation-id-label">{{ key }}</code>
        <button
          type="button"
          class="req-automation__copy"
          (click)="copyKey()"
          [attr.aria-label]="'requirements.form.automation.copy' | translate"
        >
          <mat-icon class="req-automation__copy-icon" aria-hidden="true">
            {{ copied() ? 'check' : 'content_copy' }}
          </mat-icon>
          {{ (copied() ? 'requirements.form.automation.copied' : 'requirements.form.automation.copy') | translate }}
        </button>
      </div>
      <p class="req-automation__hint">{{ 'requirements.form.automation.idHint' | translate }}</p>
    } @else {
      <p class="req-automation__hint req-automation__hint--pending">
        {{ 'requirements.form.automation.idPending' | translate }}
      </p>
    }
  </div>

  <div class="req-automation__field">
    <div id="req-automation-status-label" class="req-automation__label">
      {{ 'requirements.form.automation.statusLabel' | translate }}
    </div>
    <div class="req-automation__status" role="group" aria-labelledby="req-automation-status-label">
      @for (option of statusOptions; track option.value) {
        <button
          type="button"
          class="req-automation__status-btn req-automation__status-btn--{{ option.modifier }}"
          [class.req-automation__status-btn--active]="status() === option.value"
          [attr.aria-pressed]="status() === option.value"
          [disabled]="readOnly()"
          (click)="selectStatus(option.value)"
        >
          <span class="req-automation__dot" aria-hidden="true"></span>
          {{ option.labelKey | translate }}
        </button>
      }
    </div>
  </div>

  <div class="req-automation__field">
    <mat-form-field appearance="outline" class="req-automation__select-field">
      <mat-label>{{ 'requirements.form.automation.frameworkLabel' | translate }}</mat-label>
      <mat-select [formControl]="frameworkControl()">
        <mat-option [value]="null">{{ 'requirements.form.automation.frameworkNone' | translate }}</mat-option>
        @for (opt of frameworkOptions; track opt.value) {
          <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</section>
